import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-50fa6b3a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "user-exam-container"
};
var _hoisted_2 = {
  class: "user-exam-header-outer-container"
};
var _hoisted_3 = {
  class: "user-exam-body-outer-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UserExamHeader = _resolveComponent("UserExamHeader");
  var _component_UserExamBody = _resolveComponent("UserExamBody");
  var _component_CheatMask = _resolveComponent("CheatMask");
  var _component_RecordScreen = _resolveComponent("RecordScreen");
  var _component_AiArea = _resolveComponent("AiArea");
  var _component_ScreenShareShow = _resolveComponent("ScreenShareShow");
  var _component_NeedH5Screen = _resolveComponent("NeedH5Screen");
  return _openBlock(), _createElementBlock(_Fragment, null, [!_ctx.loading && _ctx.recordVideoService.showAnswerArea ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_UserExamHeader)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_UserExamBody)]), !_ctx.examService.answerMode && !_ctx.hideCheatMask ? (_openBlock(), _createBlock(_component_CheatMask, {
    key: 0
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_RecordScreen), _ctx.examService.useTrtcFlag ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_AiArea), _createVNode(_component_ScreenShareShow), _createVNode(_component_NeedH5Screen)], 64)) : _createCommentVNode("", true)], 64);
}